import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'liberro-disclaimer',
  standalone: false,
  templateUrl: './liberro-disclaimer.component.html',
  styleUrl: './liberro-disclaimer.component.less'
})
export class LiberroDisclaimerComponent {
  @Input() public iconSrc!: string;
  @Input() public titleKey!: string;
  @Input() public titleParams?: Record<string, unknown>;
  @Input() public descriptionKey = '';
  @Input() public descriptionParams?: Record<string, unknown>;
  @Input() public descriptionTemplate: TemplateRef<unknown> | null = null;
  @Input() public hasActions = false;
  @Input() public showProgress = false;
  @Input() public progressValue = 0;
  @Input() public variant: 'success' | 'warning' | 'danger' | 'secondary' = 'success';
  @Input() public customMargin = '';
  @Input() public customPadding = '16px';
}
